import { Client, OperationResult } from "urql";
import {
  LiveEventUbInputType,
  OfferCrewLiveEventMutation,
  OfferCrewLiveEventMutationVariables,
} from "../gql/graphql";
import { graphql } from "../gql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

const offerCrewLiveEventMutation: TypedDocumentNode<
  OfferCrewLiveEventMutation,
  OfferCrewLiveEventMutationVariables
> = graphql(`
  mutation offerCrewLiveEvent($crewLiveEvent: LiveEventUBInputType!) {
    offerCrewLiveEvent(crewLiveEvent: $crewLiveEvent)
  }
`);

export const CrewLiveEventPusher = {
  offerCrewLiveEvent(
    crewLiveEvent: LiveEventUbInputType,
    graphQlClient: Client,
  ): Promise<string> {
    return graphQlClient
      .mutation(offerCrewLiveEventMutation, { crewLiveEvent: crewLiveEvent })
      .toPromise()
      .then((result: OperationResult<OfferCrewLiveEventMutation, object>) => {
        if (result.error === undefined && result.data !== undefined) {
          const resultString = result.data.offerCrewLiveEvent;
          return Promise.resolve(resultString);
        } else {
          return Promise.reject(result);
        }
      });
  },
} as const;
